"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubReactionChuteBrusqueValeurInvestissement = void 0;
exports.ESubReactionChuteBrusqueValeurInvestissement = {
    vendre: "vendre",
    conserver: "conserver",
    investir: "investir",
};
